import { createSelector } from 'reselect';

export const selectCourtManagerState = (state: any) =>
  state.get('courtManagerState');

export const makeSelectAssignedClaims = () =>
  createSelector(selectCourtManagerState, courtManagerState => {
    if (courtManagerState && courtManagerState.get('assignedClaims')) {
      return courtManagerState.get('assignedClaims').toJS();
    }
    return [];
  });

export const makeSelectAssignedClaimsCount = () =>
  createSelector(selectCourtManagerState, courtManagerState => {
    if (courtManagerState && courtManagerState.get('assignedClaimsCount')) {
      return courtManagerState.get('assignedClaimsCount');
    }
    return 0;
  });
